// extracted by mini-css-extract-plugin
export default {"wrap":"ByjIb","card":"r1AU7","card-image":"gGt7V","card-image-wrapper":"oxkn0"};